import Module from 'epa-components-platform/src/lib/helper/js/Module';

export default class Body extends Module  {
  constructor(el) {
    super();

    this.el = el;
    this.initScrollForAuthNotification();
  }

  initScrollForAuthNotification = () => {
    const nowTime = (new Date()).getTime();
    const showNotificationTime = localStorage.getItem('showAuthNotificationAfter');

    if (nowTime < showNotificationTime) { return; }

    // window.addEventListener('scroll', this.handleScrollForAuthNotification);
  }

  handleScrollForAuthNotification = () => {
    let scrollValue = window.scrollY;
    const bodyHeight = this.el.offsetHeight;
    const scrollHeight = bodyHeight - window.innerHeight;
    const showNotificationPoint = scrollHeight * 30 / 100; // 30% высоты

    if (scrollValue > showNotificationPoint) {
      // this.triggerEvent('notification:auth');
      window.removeEventListener('scroll', this.handleScrollForAuthNotification)
    }
  }

}